
import '../pages/Gachapon.scss';
import { Rabbit, Prize } from "../api/types";
import exp from "../components/exp-table.json"
import { useNavigate } from "react-router-dom";
import request from "../api/request";
import { useEffect, useState } from 'react';
import { LAMPORTS_PER_SOL } from '@solana/web3.js';

const getProb = (type:string) => {
  switch (type) {
    case "jackpot":
        return "1%"
      break;
    case "grand":
        return "3%"
      break;
    case "rabbit":
        return "0.5%"
      break;
  case "spl_token":
        return "15%"
      break;
  case "raffle_ticket":
        return "35%"
      break;
  case "spin_token":
        return "25%"
      break;
    default:
      break;
  }
}

const RewardsItem = (props:any) => {
    const isLocked = (props.locked > props.currentExp)
    const lockLevel = findLevel(props.locked)
    const [floorPrice, setFloorPrice] = useState(0)

    return (
        <div className={`Rewards--Item ${props.isJackpotPrize ? "jackpot-prizes" : ""} ${props.isRabbitPrize ? "rabbit-prizes" : ""}`}>
            
            <div className={`Rewards--Item--Img`}>
              <img src={props.src}/>
            </div>
            <div className={`Rewards--Item--Details`}>
              <span className={`Rewards--Item--Details-Name`}>{props.name} <a target={`_blank`} title={'View on Solscan'} href={`https://solscan.io/token/${props.mint}`}><img  src={`/thumbnails/solscan.svg`}/></a></span>
              {props.floorPrice ? <span className={`Rewards--Item--Details-Price`}>FP: {props.floorPrice.toFixed(2)} SOL </span> : null }
            </div>
            <span className={`Rewards--Item--Details-Prob`}>Win: {getProb(props.type)}</span>
        </div>
    )
}

const findLevel = (xp:number) => {
    var experience: { [key:string] : number} = exp
    var returnLevel = 0
    var objKeys = Object.keys(experience)
    for(var e in objKeys){
      const expNumber = Number(experience[objKeys[e]])
      if(expNumber <= xp){
        returnLevel = Number(objKeys[e])
      }
    }
    return (returnLevel == 0) ? 1 : returnLevel;
  }

const RewardsList = ({rewards, currentRabbit, pay2SpinEnabled, prizes}: {rewards:any, currentRabbit: Rabbit, pay2SpinEnabled:boolean, prizes:any}) => {
    let reward = "<div>There's always</div><br><span>a prize for you</span>"
    // let reward = (pay2SpinEnabled) ? "<div>There's always</div><br><span>a prize for you</span>" : "PRizes"
    let navigate = useNavigate();
    const [gachitPrizes, setGachit] = useState([])
    useEffect(() => {
        prizes?.sort((a:any, b:any) => {
            // const nameA = a.type.toUpperCase(); // ignore upper and lowercase
            // const nameB = b.type.toUpperCase(); // ignore upper and lowercase
            // const nameA = a.floorPrice; // ignore upper and lowercase
            // const nameB = b.floorPrice
            // const catA = a.isJackpotPrize; // ignore upper and lowercase
            // const catB = b.isRabbitPrize
            // if (nameA < nameB) {
            //   return 1;
            // }
            // if (nameA > nameB) {
            //   return -1;
            // }

            if (a.type > b.type) return -1;
            if (a.type < b.type) return 1;

            // If ages are equal, compare by name
            if (a.floorPrice > b.floorPrice) return -1;
            if (a.floorPrice < b.floorPrice) return 1;
          
            // names must be equal
            return 0;
          })
        setGachit(prizes)
    }, [prizes])
    
    
    
    return (
        <div className={`RewardsList--Container ${pay2SpinEnabled ? "gachit" : ""}`}>
            <div className="RewardsList--Title" dangerouslySetInnerHTML={{ __html: reward}}></div>
            <div className="RewardsList--Items">
                { gachitPrizes && gachitPrizes.slice(0,9).map((item:any, index:number) => {
                    return <RewardsItem isJackpotPrize={(item.type==="jackpot")} key={index} mint={item.mint} type={item.type} name={item.name} floorPrice={item.floorPrice} src={`https://img-cdn.magiceden.dev/rs:fill:640:640:0:0/plain/${item.image}`} locked={false}/>
                })}
            </div>
            <div className="RewardsList--Button" onClick={() => { navigate("/prizes")  }}>{"See more..."}</div> 
        </div>
    )
}

export default RewardsList